import BaseView from './BaseView';
import './BaseView.scss';

export default BaseView;
